var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWaste(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.8125 3.75H6.885C7.13189 3.75004 7.37497 3.68913 7.59267 3.57269C7.81038 3.45625 7.99598 3.28787 8.133 3.0825L8.742 2.1675C8.87902 1.96213 9.06462 1.79375 9.28233 1.67731C9.50003 1.56087 9.74311 1.49996 9.99 1.5H13.356C13.6709 1.49992 13.9779 1.59898 14.2334 1.78314C14.4889 1.96729 14.68 2.22719 14.7795 2.526L15.1875 3.75M16.3125 3.75H6.5625",
    stroke: "#FF9500",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1875 3.75L14.8125 8.625M3.9375 3.75L4.39125 11.652C4.50675 13.5795 4.56525 14.544 5.04675 15.237C5.2845 15.5805 5.59125 15.8692 5.94675 16.0867C6.38325 16.3537 6.90975 16.4588 7.6875 16.5M8.8125 11.6235L9.6645 12.723C9.81925 12.1453 10.1431 11.6271 10.5946 11.2348C11.046 10.8425 11.6044 10.5941 12.198 10.5215C12.7916 10.4489 13.3934 10.5553 13.9261 10.8272C14.4588 11.099 14.898 11.5239 15.1875 12.0472M16.3125 15.3735L15.4605 14.2755C15.307 14.8487 14.9869 15.3635 14.5408 15.7547C14.0947 16.146 13.5426 16.3962 12.9543 16.4737C12.366 16.5512 11.7679 16.4524 11.2358 16.19C10.7036 15.9275 10.2612 15.5131 9.9645 14.9993",
    stroke: "#FF9500",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaste);
export default __webpack_public_path__ + "static/media/waste.cc27433ff4601cd2a77de7ede77e1e6a.svg";
export { ForwardRef as ReactComponent };